import styled from 'styled-components'

export const Modal = styled.div`
  top: 10rem;

  & div[class^='Contentstyled__Content'] {
    padding: 0;
  }

  @media (max-width: 767px) {
    top: 6rem;

    & div[class^='Headerstyled__Header'] {
      padding: 2rem;
    }

    & div[class^='FixModalstyled__Modal'] {
      width: auto;
      max-width: 400px;
    }
  }
`

export const ModalTitle = styled.h4`
  margin: 0;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;

  @media (max-width: 767px) {
    font-size: 20px;
    line-height: 26px;
  }
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`

export const Row = styled.li`
  display: flex;
  column-gap: 20px;
  padding: 15px 40px;

  &:nth-child(odd) {
    background-color: #f5f7ff;
  }

  @media (max-width: 767px) {
    padding: 15px 20px;
    flex-direction: column;
    row-gap: 10px;
  }
`

export const Title = styled.h5`
  margin: 0;
  flex: 0 0 240px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.black[20]};

  @media (max-width: 767px) {
    flex-basis: unset;
  }
`

export const Description = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.black[40]};
`
